module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('product', {
    attrs: {
      "title": "Køl / Frys"
    }
  }, [_c('div', {
    attrs: {
      "slot": "description"
    },
    slot: "description"
  }, [_c('p', [_vm._v("\n            P. Pedersen & Søn transporterer temperaturkontrollerede køl- og frostvarer med temperaturer ned til -30 grader.\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n            P. Pedersen & Søn har certificering inden for fødevaresikkerhed og fødevarehygiejne.\n        ")]), _vm._v(" "), _c('p'), _c('div', {
    staticClass: "btn-holder alt"
  }, [_c('a', {
    staticClass: "btn-primary text-center text-uppercase active md-round",
    attrs: {
      "href": "/static/images/kontrolrapport.pdf",
      "rel": "noopener",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o fa-fw"
  }), _vm._v(" Se certifikat\n                ")]), _vm._v("\n                Certifikatet kan også findes på Fødevarestyrelsens hjemmeside. ")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "product-image",
    attrs: {
      "src": "/static/images/koel_frys.jpg"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1729a072"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/products/koel.vue
// module id = 254
// module chunks = 1